import { render, staticRenderFns } from "./customerManagement.vue?vue&type=template&id=36bc04f4&"
import script from "./customerManagement.vue?vue&type=script&lang=js&"
export * from "./customerManagement.vue?vue&type=script&lang=js&"
import style0 from "./customerManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports